import React from 'react';
import Link from '../../shared/components/hyperlink';
import ConditionalWrapper from '../../shared/components/conditional-wrapper';
import { withProductPrice } from '../../product/components/product-price/with-product-price';

import './add-to-cart.less';

const EMPTY_OBJECT = {};

const AddToCart = props => {
    const { product = EMPTY_OBJECT, price = EMPTY_OBJECT, ctaLink, text, className } = props;
    const { stock, preOrder } = price;
    const { slug, prdClass } = product;
    let isParentPrd = prdClass === 'PRT';

    const pdpUrl = `/pdp/${slug}`;
    let ctaText;

    if (stock === 0 && !isParentPrd) {
        ctaText = 'OUT OF STOCK';
    } else {
        ctaText = text.trim() || 'BUY NOW';
    }

    return (
        <ConditionalWrapper
            condition={ctaLink || stock === 0 || isParentPrd || preOrder}
            wrapper={children => {
                let linkUrl = ctaLink || pdpUrl;
                return <Link to={linkUrl}>{children}</Link>;
            }}
        >
            <button
                aria-label={ctaText}
                className={'add-to-cart' + (className ? ` ${className}` : '')}
                onClick={isParentPrd || stock === 0 || !!ctaLink ? null : props.openModal}
            >
                {ctaText}
            </button>
        </ConditionalWrapper>
    );
};

AddToCart.defaultProps = {
    text: 'BUY NOW',
};

export default withProductPrice(AddToCart);
